var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { compare } from "compare-versions";
import { MetapageHashParams } from "./Shared";
import { VersionsMetapage, MetapageVersionCurrent } from "./v0_4";
export const convertToCurrentDefinition = (def) => {
    if (def === null) {
        throw "Metapage definition cannot be null";
    }
    if (typeof def === "string") {
        try {
            def = JSON.parse(def);
        }
        catch (err) {
            throw `Cannot parse into JSON:\n${def}`;
        }
    }
    let updatedDefinition;
    switch (getMatchingVersion(def.version)) {
        case VersionsMetapage.V0_2:
            {
                updatedDefinition = convertToCurrentDefinition(definition_v0_2_to_v0_3(def));
                break;
            }
        case VersionsMetapage.V0_3:
            {
                updatedDefinition = def;
                break;
            }
        default:
            console.warn(`Metapage definition version=${def.version} but we only know up to version ${MetapageVersionCurrent}. Assuming the definition is compatible, but it's the future!`);
            updatedDefinition = def;
            break;
    }
    return updatedDefinition;
};
const definition_v0_2_to_v0_3 = (old) => {
    old.version = VersionsMetapage.V0_3;
    return old;
};
export const merge = (current, newInputs) => {
    if (!newInputs) {
        return false;
    }
    let modified = false;
    Object.keys(newInputs).forEach((pipeId) => {
        modified = true;
        if (newInputs[pipeId] === undefined) {
            delete current[pipeId];
        }
        else {
            current[pipeId] = newInputs[pipeId];
        }
    });
    return modified;
};
export const getMatchingVersion = (version) => {
    if (version == "latest") {
        return MetapageVersionCurrent;
    }
    else if (compare(version, "0.2", "<")) {
        throw `Unknown version: ${version}`;
    }
    else if (compare(version, "0.2", ">=") && compare(version, VersionsMetapage.V0_3, "<")) {
        return VersionsMetapage.V0_2;
    }
    else if (compare(version, "0.3", ">=")) {
        return VersionsMetapage.V0_3;
    }
    else {
        console.log(`Could not match version=${version} to any known version, assuming ${MetapageVersionCurrent}`);
        return MetapageVersionCurrent;
    }
};
export const getUrlParam = (key) => {
    if (!window.location.search) {
        return null;
    }
    return new URLSearchParams(window.location.search).get(key);
};
export const getUrlParamDebug = () => {
    return new URLSearchParams(window.location.search).has(MetapageHashParams.mp_debug);
};
export const isDebugFromUrlsParams = () => {
    const param = new URLSearchParams(window.location.search).get(MetapageHashParams.mp_debug);
    return param === "true" || param === "1";
};
export const existsAnyUrlParam = (k) => {
    const members = k.filter((param) => {
        return new URLSearchParams(window.location.search).has(param);
    });
    return members.length > 0;
};
export const generateMetaframeId = (length = 8) => {
    return generateId(length);
};
export const generateMetapageId = (length = 8) => {
    return generateId(length);
};
export const generateNonce = (length = 8) => {
    return generateId(length);
};
const LETTERS = "abcdefghijklmnopqrstuvwxyz0123456789";
export const generateId = (length = 8) => {
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = LETTERS.length;
    for (var i = 0; i < length; i++) {
        result += LETTERS.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};
export const log = (o, color, backgroundColor) => {
    color = color
        ? color
        : "000";
    if (color && color.trim() == "") {
        color = undefined;
    }
    let s;
    if (typeof o === "string") {
        s = o;
    }
    else if (typeof o === "number") {
        s = o + "";
    }
    else {
        s = JSON.stringify(o, null, "  ");
    }
    if (color && color.trim() != "") {
        var cssstring = `color: #${color}`;
        if (backgroundColor) {
            cssstring = `${cssstring}; background: #${backgroundColor}`;
        }
        s = `%c${s}`;
        window.console.log(s, cssstring);
    }
    else {
        window.console.log(s);
    }
};
export const stringToRgb = (str) => {
    return intToRGB(hashCode(str));
};
export const hashCode = (str) => {
    var hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
};
export const intToRGB = (i) => {
    var c = (i & 0x00ffffff).toString(16).toUpperCase();
    return "00000".substring(0, 6 - c.length) + c;
};
export const isPageLoaded = () => {
    return document.readyState == "complete" || document.readyState == "interactive";
};
export const pageLoaded = () => __awaiter(void 0, void 0, void 0, function* () {
    if (isPageLoaded()) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        if (isPageLoaded()) {
            resolve();
            return;
        }
        let loaded = false;
        window.addEventListener('load', () => {
            if (loaded) {
                return;
            }
            loaded = true;
            resolve();
        });
        const timer = setTimeout(() => {
            if (!loaded && isPageLoaded()) {
                loaded = true;
                resolve();
            }
        }, 200);
    });
});
//# sourceMappingURL=MetapageTools.js.map